import { Component, EventEmitter, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-create-contact-modal",
  templateUrl: "./create-contact-modal.component.html",
})
export class CreateContactModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<IContact>();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.CreateContact;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit(contact: IContact) {
    this._modalService.closeModal();
    this.submit.emit(contact);
  }
}
